import { fetchViews } from 'components/Graph/commands/fetchViews';
import { withGraphsLoadingIndicator } from 'components/Graph/commands/helpers/withGraphsLoadingIndicator';
import { loadPresets } from 'components/Graph/commands/settings/loadPresets';
import { loadGraphFonts } from 'components/Graph/helpers/loadGraphFonts';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { loadGraphResources } from 'components/Graph/resources/resources';
import { loadAdvancedOptions } from './pathLookup/advancedOptions/loadAdvancedOptions';

export const loadGraphInitialData: GraphCommandFactory =
  (cmdContext, dispatch) => async () => {
    await withGraphsLoadingIndicator(cmdContext)(() =>
      Promise.all([
        dispatch(loadPresets),
        dispatch(loadAdvancedOptions),
        dispatch(fetchViews),
        loadGraphResources(),
        // load svg font versions for graph-utils (metrics calculations and svg export)
        loadGraphFonts(),
      ]),
    );
  };
